var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sms_logo_div"},_vm._l((_vm.snsList),function(sns,idx){return _c('a',{key:idx,staticClass:"sms_logo",style:(("background-image:url('images/basic/icon/" + (sns.icon) + "')")),attrs:{"href":sns.link}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }